import { useMemo } from "react";

import Icon, { type IconProps, type AppIconDefinition } from "src/components/common/Icon";
import { place } from "src/components/common/iconComposition";
import type { ILayoutBreadcrumb } from "src/contexts/layouts/LayoutContext";

/**
 * Creates two offset, scaled copies of an icon with knockout enabled on every layer.
 */
export const createCollectionIcon = (icon: AppIconDefinition): AppIconDefinition =>
    [...place(icon, 0.625, 3, -3), ...place(icon, 0.625, -3, 3)].map(layer => ({
        ...layer,
        knockout: true
    }));

/**
 * Defines the inputs accepted by this layout component.
 */
export interface BreadcrumbIconProps extends IconProps {
    iconStyle?: ILayoutBreadcrumb["iconStyle"];
}

/**
 * Renders a single identity icon or its memoized collection composition.
 */
const BreadcrumbIcon = ({ icon, iconStyle = "single", ...props }: BreadcrumbIconProps) => {
    const definition = useMemo(
        () => (iconStyle === "collection" ? createCollectionIcon(icon) : icon),
        [icon, iconStyle]
    );
    return (
        <Icon
            icon={definition}
            {...props}
        />
    );
};

export default BreadcrumbIcon;
